import axios from "axios";

export const fetchWeeks = async (nrOfWeeks, companyCode) => {
    const response = await axios.get("api/calendar/weeks/?nrOfWeeks=" + nrOfWeeks + "&companyCode=" + companyCode);
    const weeks = response.data;
    return weeks;
}